// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"341f1ef5","453":"88113c3b","455":"e2d0d8db","977":"d39ca8bc"}[chunkId] + ".chunk.js";
};